module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "StatusWaveDetail"
  }, [(_vm.statusData && _vm.statusData.Wave) ? _c('div', {
    staticClass: "swd-meta-data"
  }, [_c('h4', [_c('b', [_vm._v(_vm._s(_vm.statusData.Wave.WaveName))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.toLocaleDateString(_vm.statusData.Wave.WaveSince)) + " - " + _vm._s(_vm.globals.toLocaleDateString(_vm.statusData.Wave.WaveUntil)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "20%",
      "margin-left": "12px"
    }
  }, [_c('select2', {
    ref: "approvalStatusSelect",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.AWS036,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.getWaveStatus()
      }
    },
    model: {
      value: (_vm.selectedApprovalStatus),
      callback: function($$v) {
        _vm.selectedApprovalStatus = $$v
      },
      expression: "selectedApprovalStatus"
    }
  }, [_c('option', {
    attrs: {
      "value": "approved"
    }
  }, [_vm._v("Approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "none"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "open"
    }
  }, [_vm._v("Open")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "swd-two-col"
  }, [(_vm.statusData && _vm.statusData.SurveyInstances) ? _c('div', {
    staticClass: "stat-container"
  }, [_c('b', {
    staticClass: "stat-container-title"
  }, [_vm._v(_vm._s(_vm.lang.AWS005))]), _vm._v(" "), _c('div', {
    staticClass: "stat-row"
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.SurveyInstances.Status.Count,
      "label": _vm.lang.AWS006,
      "centerText": _vm.statusData.SurveyInstances.Status.Count,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.SurveyInstances.Status.Approval,
      "label": _vm.lang.AWS007,
      "centerText": _vm.statusData.SurveyInstances.Status.Approval,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.SurveyInstances.Status.InProgress,
      "label": _vm.lang.AWS008,
      "centerText": _vm.statusData.SurveyInstances.Status.InProgress,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.SurveyInstances.Status.Reporting,
      "label": _vm.lang.AWS009,
      "centerText": _vm.statusData.SurveyInstances.Status.Reporting,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Wave.InTime,
      "label": _vm.lang.AWS010,
      "centerText": _vm.statusData.Wave.InTime,
      "isPercentage": true,
      "suffix": "%"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusData && _vm.statusData.Approvals) ? _c('div', {
    staticClass: "stat-container"
  }, [_c('b', {
    staticClass: "stat-container-title"
  }, [_vm._v(_vm._s(_vm.lang.AWS011))]), _vm._v(" "), _c('div', {
    staticClass: "stat-row"
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Approvals.None,
      "label": _vm.lang.AWS012,
      "centerText": _vm.statusData.Approvals.None,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Approvals.Open,
      "label": _vm.lang.AWS013,
      "centerText": _vm.statusData.Approvals.Open,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Approvals.Approved,
      "label": _vm.lang.AWS014,
      "centerText": _vm.statusData.Approvals.Approved,
      "isPercentage": true,
      "suffix": "%"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.statusData && _vm.statusData.Shopper) ? _c('div', {
    staticClass: "stat-container"
  }, [_c('b', {
    staticClass: "stat-container-title"
  }, [_vm._v(_vm._s(_vm.lang.AWS015))]), _vm._v(" "), _c('div', {
    staticClass: "stat-row"
  }, [(_vm.statusData.Shopper.Gender) ? _c('div', {
    staticClass: "special-stat-container"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS016))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Gender.Male,
      "label": _vm.lang.AWS017,
      "centerText": _vm.statusData.Shopper.Gender.Male,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Gender.Female,
      "label": _vm.lang.AWS018,
      "centerText": _vm.statusData.Shopper.Gender.Female,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Gender.Divers,
      "label": 'Divers',
      "centerText": _vm.statusData.Shopper.Gender.Divers,
      "isPercentage": true,
      "suffix": "%"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Age) ? _c('div', {
    staticClass: "special-stat-container"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS019))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Age.Min,
      "label": _vm.lang.AWS020,
      "centerText": _vm.statusData.Shopper.Age.Min,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Age.Max,
      "label": _vm.lang.AWS021,
      "centerText": _vm.statusData.Shopper.Age.Max,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Age.Above70,
      "label": _vm.lang.AWS022,
      "centerText": _vm.statusData.Shopper.Age.Above70,
      "isPercentage": true,
      "suffix": "%"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Distance) ? _c('div', {
    staticClass: "special-stat-container"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS023))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Distance.Min / 1000,
      "label": _vm.lang.AWS020,
      "centerText": _vm.statusData.Shopper.Distance.Min / 1000,
      "showRing": false,
      "showSquare": true,
      "decimalPlaces": 0,
      "suffix": " km"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Distance.Max / 1000,
      "label": _vm.lang.AWS021,
      "centerText": _vm.statusData.Shopper.Distance.Max / 1000,
      "showRing": false,
      "showSquare": true,
      "decimalPlaces": 0,
      "suffix": " km"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Car) ? _c('div', {
    staticClass: "special-stat-container"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS024))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Car.YearOfBuild.Min,
      "label": _vm.lang.AWS020,
      "centerText": _vm.statusData.Shopper.Car.YearOfBuild.Min,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Shopper.Car.YearOfBuild.Max,
      "label": _vm.lang.AWS021,
      "centerText": _vm.statusData.Shopper.Car.YearOfBuild.Max,
      "showRing": false,
      "showSquare": true
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.statusData.Model) ? _c('div', {
    staticClass: "special-stat-container"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS025))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Model.Downgrade,
      "label": _vm.lang.AWS026,
      "centerText": _vm.statusData.Model.Downgrade,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Model.Match,
      "label": _vm.lang.AWS027,
      "centerText": _vm.statusData.Model.Match,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.statusData.Model.Upgrade,
      "label": _vm.lang.AWS028,
      "centerText": _vm.statusData.Model.Upgrade,
      "isPercentage": true,
      "suffix": "%"
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.statusData && _vm.statusData.CarDistribution) ? _c('div', {
    staticClass: "stat-container"
  }, [_c('b', {
    staticClass: "stat-container-title"
  }, [_vm._v(_vm._s(_vm.lang.AWS037))]), _vm._v(" "), _c('table', {
    staticClass: "car-distribution-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.WV0044))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.statusData.CarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("Audi")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.SetValue,
        "centerText": model.SetValue,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ActualValue,
        "centerText": model.ActualValue,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountDowngrade_percentage,
        "centerText": model.ApprovedCarCountDowngrade_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountMatch_percentage,
        "centerText": model.ApprovedCarCountMatch_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountUpgrade_percentage,
        "centerText": model.ApprovedCarCountUpgrade_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1)])
  }), _vm._v(" "), _vm._l((_vm.statusData.CompetitorCarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CompetitorCarBrand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.CompetitorCarModel))]), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.SetValue,
        "centerText": model.SetValue,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ActualValue,
        "centerText": model.ActualValue,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountDowngrade_percentage,
        "centerText": model.ApprovedCarCountDowngrade_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountMatch_percentage,
        "centerText": model.ApprovedCarCountMatch_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1), _vm._v(" "), _c('td', [_c('StatIndicator', {
      attrs: {
        "value": model.ApprovedCarCountUpgrade_percentage,
        "centerText": model.ApprovedCarCountUpgrade_percentage,
        "isPercentage": true,
        "suffix": "%"
      }
    })], 1)])
  })], 2)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-262816f8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatusManagement/StatusWaveDetail.vue
// module id = 1664
// module chunks = 1